export enum NursingAllowanceCareTypeEnum {
    LONG_TERM = 'L',
    SHORT_TERM = 'N',
}
